import {runValidations, runValidationsAfterChange} from '../validationsService/validationsService';
import {valueValidatableClearance} from './valueValidatableInitialize';

const validationsEventHandler = (RMI) => (e) => {
    const value = e.target.checked;
    const compId = e.syntheticEvent.id;

    runValidationsAfterChange(RMI, compId, value);
};

const updateValidationState = (RMI, compId) => runValidations(RMI, compId);

const booleanInputInitialize = (RMI, contextId, compId) => {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

const booleanInputClearance = (RMI, contextId, compId) => valueValidatableClearance(RMI, contextId, compId);

export {booleanInputInitialize, booleanInputClearance};
